// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_jr-0";